export const GET_MATCHING_DATA = "GET_MATCHING_DATA"
export const GET_MATCHING_DATA_SUCCESS = "GET_MATCHING_DATA_SUCCESS"
export const GET_MATCHING_DATA_FAIL = "GET_MATCHING_DATA_FAIL"